import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import ActivityCodeList from './ActivityCodeList.jsx';

import { useStateValue } from '../context/state.jsx';
import { setProjectViewType, setProjectGroupBy, setProjectGroupByActivityCode } from '../context/datasets.js';

const GroupByList = ({
	projectViewType,
	projectGroupBy,
	projectGroupByActivityCode,
	projectActivityCodesTree,
	projectActivityCodesTreeSequence
}) => {
	const [, dispatch] = useStateValue();
	const groupByListItemClick = type => {
		dispatch(setProjectViewType('Group List'));
		dispatch(setProjectGroupBy(type));
		if (type !== 'Activity Code') {
			dispatch(setProjectGroupByActivityCode(null));
		}
	};

	const groupByItems = [
		//'Area',
		'Date',
		'Float',
		'Resource'
	].map((item, index) => {
		const checked = projectViewType === 'Group List' && projectGroupBy === item;
		const classes = classnames('groupByListItemWrapper', {'no-bottom-border': item === 'Activity Code'});
		return (
			<div
				key={index}
				className={classes}>
				<ListGroupItem
					onClick={() => { groupByListItemClick(item); }}>
					<input
						type="radio"
						className="groupByRadio"
						name="groupByRadio"
						value={item}
						checked={checked}
						readOnly />
					{item}
				</ListGroupItem>
			</div>
		);
	});
	const header = (
		<div>
			<input
				type="radio"
				className="projectViewTypeRadio"
				name="projectViewTypeRadio"
				value="Group List"
				checked={projectViewType === 'Group List'}
				readOnly />
			Group List
			<span className="glyphicon glyphicon-plus rightGlyph"></span>
			<span className="glyphicon glyphicon-minus rightGlyph"></span>
		</div>
	);
	return (
		<Panel className="groupByListPanel">
			<Panel.Heading>
				<Panel.Title toggle>{header}</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup>
					{groupByItems}
					<ActivityCodeList
						projectViewType={projectViewType}
						projectGroupBy={projectGroupBy}
						projectGroupByActivityCode={projectGroupByActivityCode}
						groupByListItemClick={groupByListItemClick}
						projectActivityCodesTree={projectActivityCodesTree}
						projectActivityCodesTreeSequence={projectActivityCodesTreeSequence} />
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

export default GroupByList;

GroupByList.propTypes = {
	projectViewType: PropTypes.string,
	projectGroupBy: PropTypes.string,
	projectGroupByActivityCode: PropTypes.string,
	projectActivityCodesTree: PropTypes.object,
	projectActivityCodesTreeSequence: PropTypes.array
};